<template>
    <div class="panel">
        <div class="panel-body">
            <div class="row">
                <form class="form-horizontal" style="padding-top:10px" id="bs_form">
                    <!--培训项目-->
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="col-sm-4 control-label">报考专业</label>
                            <div class="col-sm-8">
								<BootstrapCombobox :data="pcList" text-field="mc" value-field="id" v-model="query.pcId" placeholder="-报考专业筛选-" :formatOption="(item)=>(item.xmbh+'-'+item.mc)"></BootstrapCombobox>
                            </div>
                        </div>
                    </div>
                    <!--课程-->
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="col-sm-4 control-label">课程</label>
                            <div class="col-sm-8">
                                <BootstrapCombobox :data="kcList" value-field="id" text-field="kcmc" v-model="query.kcId" placeholder="-课程筛选-" :format-option="(item)=>(item.kcdm+'-'+item.kcmc)"></BootstrapCombobox>
                            </div>
                        </div>
                    </div>
                    <!--学员单位-->
                    <!--<div class="col-sm-4" v-if="js == 'YWGLY' || js == 'ZYPX_YWGLY'">
                        <div class="form-group">
                            <label class="col-sm-4 control-label">学员单位</label>
                            <div class="col-sm-8">
								<BootstrapCombobox :data="qyList" value-field="id" text-field="qymc" v-model="query.qyId" placeholder="-学员单位筛选-"></BootstrapCombobox>
                            </div>
                        </div>
                    </div>-->
                    <!--相识度范围-->
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="col-sm-4 control-label">相识度范围</label>
                            <div class="col-sm-8">
                                <select name="xsdfw" v-model="query.xsdfw" class="form-control">
                                    <option value="">-请选择-</option>
                                    <option value="0~30">0~30</option>
                                    <option value="30~60">30~60</option>
                                    <option value="60~100">60~100</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <!--是否通过比对-->
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="col-sm-4 control-label">是否比对通过</label>
                            <div class="col-sm-8">
                                <select name="sftgbd" v-model="query.sftg" class="form-control">
                                    <option value="">-请选择-</option>
                                    <option value="1">通过</option>
                                    <option value="0">不通过</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="col-sm-4 control-label">考生关键字</label>
                            <div class="col-sm-8">
                                <input type="text" name="ksWord" v-model="query.ksWord" v-validate="{required:true,max:50}" class="form-control" data-vv-as="考生关键字"  placeholder=""/>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <div class="pull-right">
                            <button @click="search()" type="button" class="btn btn-primary btn-sm"
                                    style="margin-right:3px"><i class="fa fa-search" aria-hidden="true"></i>搜索
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="row">
                <div class="col-sm-12" style="padding-top: 10px">
                    <BootstrapTable style="font-size: 14px;"
                                    ref="table"
                                    v-once
                                    :columns="columns"
                                    :options="{
										classes:'table table-hover',
                                    	undefinedText:'',
                                        showColumns: false,
                                        sidePagination:'server',
                                        pagination:true,
                                        pageNumber:1,
                                        pageSize:10,
                                        pageList:[10,50,100,500],
                                        paginationPreText:'上一页',
                                        paginationNextText:'下一页',
                                        showExtendedPagination:true,
                                        paginationLoop:false
                                    }"
                                    @onPostBody="vueFormatterPostBody"
                                    @onPageChange="pageChange"
                    />
                </div>
            </div>
        </div>
		<HomeworkPhotoCompare ref="HomeworkPhotoCompare"></HomeworkPhotoCompare>
    </div>
</template>
<script>

    /**
     * 平时作业  作业监控
     */

    import tableMixin from '@/mixins/table.js';  //表格
    import HomeworkPhotoCompare from './HomeworkPhotoCompare.vue'

    export default {
        mixins: [tableMixin],
        name: "HomeworkMonitor",
        components :{
			HomeworkPhotoCompare
        },
        data: function () {
            return {
                js: this.$store.state.user.js,
                pcList: [],
                kcList: [],
                qyList:[],
                djztList:[],
                query: {
                    pcId: '',
                    kcId: '',
                    qyId: '', //学员单位
                    xsdfw: '',//相识度范围
                    sftg: '',//是否通过比对
                    ksWord: '',
                },
                columns: [
                    {
                        field: 'pcmc',
                        title: '报考专业',
                        formatter: (value, row) => {
                            return row.xmbh + '-' + value;
                        }
                    },
                    {
                        field: 'kcmc',
                        title: '课程'
                    },
                    {
                        field: 'sjmc',
                        title: '试卷名称'
                    },
					{
					    field: 'xm',
					    title: '姓名'
					},
					{
					    field: 'sfzh',
					    title: '身份证号'
					},
                    {
                        field: 'jlsj',
                        title: '识别时间'
                    },
                    {
                        field: 'bdzxd',
                        title: '识别相识度'
                    },
                    {
                        field: 'sftg',
                        title: '比对结果',
                        formatter: (value) => {
                            return value == '0' ? '不通过' : '通过';
                        }
                    },
                    {
                        field: 'actions',
                        title: '操作',
                        align: 'center',
                        formatter: (value, row) => {
                            return this.vueFormatter({
                                template:
                                    '<div class="operation_column">'+ '<a @click="detail(row)">详情</a></div>',
                                data: {row},
                                methods: {
                                    detail: this.detail,
                                }
                            })
                        }
                    }
                ]
            }
        },
       mounted(){
       	this.query = Object.assign(this.query,{current:1,size:10},this.$route.query);
       	this.load();
       },
       beforeRouteUpdate(to, from, next){
		this.query = Object.assign(this.query,{current:1,size:10},to.query);
       	this.load();
       	next();
       },
        created: function () {
            this.getpcList();
            // this.getqyList();
            this.$store.commit('setBreadcrumb', [{name: '自学考试'}, {name: '平时作业记录'}, {name: '作业监控'}]);
        },
        watch: {  //课程列表联动
            "query.pcId": function (value) {
                if (value) {
                    this.$http.post("/htgl/biz/zypx/pszyyzjl/hqkc", {pcId: value}).then(res => {
                        this.kcList = res.data;
                    });
                }
                else {
                    this.kcList = [];
                }
            }
        },
        methods: {
            //培训项目列表
            getpcList: function () {
                this.$http.post('/htgl/biz/zypx/pszyyzjl/hqpc').then(res => {
                    this.pcList = res.data;
                });
            },
            //获取学员单位列表
            // getqyList: function () {
            //     this.$http.post('/htgl/biz/zypx/pszyyzjl/hqByQy').then(res => {
            //         if (res.data) {
            //             this.qyList = res.data;
            //         }
            //     });
            // },
            //点击详情
            detail(row) {
				this.$refs.HomeworkPhotoCompare.open({ id: row.id,
                            ksId: row.ksid,
                            xcpz: row.xcpz});
            },
            search: function () {
              //将数据表格的页码以及每一页展示的数据重置为1，10
              let query = Object.assign(this.query,{current:1,size:10},{_t:new Date().getTime()});
              this.$router.push({name:this.$route.name,query:query});
            },
            load: function (pageNumber, pageSize) {
                this.query.current = pageNumber || this.query.current;
                this.query.size = pageSize || this.query.size;
                this.$http.post('/htgl/biz/zypx/pszyjk/cx', this.query).then(res => {
                    let data = res.data;
                    //封装返回值
                    let result = {
                        total: data.total,
                        rows: data.records
                    };
                    //table加载返回的数据
                    this.$refs.table.load(result);
					this.$refs.table.refreshOptions({pageNumber:parseInt(this.query.current),
						pageSize:parseInt(this.query.size)});
                });
            },
            pageChange: function (pageNumber, pageSize) {
               let query = Object.assign(this.query,{current:pageNumber,size:pageSize},{_t:new Date().getTime()});
               this.$router.push({name:this.$route.name,query:query});
            }
        }
    }
</script>
<style scoped>

</style>
